import PropTypes from "prop-types";

import { MdChecklist, MdOutlinePendingActions } from "react-icons/md";
import DeliveryDiningOutlinedIcon from "@mui/icons-material/DeliveryDiningOutlined";
import { ImPriceTag } from "react-icons/im";
import { IoBookOutline } from "react-icons/io5";
import { FaWpforms } from "react-icons/fa";
import SettingsIcon from "@mui/icons-material/Settings";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import AutoAwesomeMosaicIcon from "@mui/icons-material/AutoAwesomeMosaic";
import { Attachment } from "@mui/icons-material";

export function AsetuksetIcon(props) {
  return <SettingsIcon {...props} />;
}
AsetuksetIcon.propTypes = {
  color: PropTypes.string,
};
export function AdminPanelIcon(prop) {
  return <AdminPanelSettingsIcon {...prop} />;
}

export function HinnatIcon(props) {
  return <ImPriceTag {...props} />;
}
export function KuvatIcon(props) {
  return <Attachment {...props} />;
}
export function LokiIcon(props) {
  return <IoBookOutline color="primary" {...props} />;
}
export function SeurantaIcon(props) {
  return <MdChecklist {...props} />;
}
export function TilausIcon(props) {
  return <FaWpforms {...props} />;
}
export function ToiminnotIcon(props) {
  return <MdOutlinePendingActions {...props} />;
}
export function ToimitusIcon(props) {
  return <DeliveryDiningOutlinedIcon {...props} />;
}
export function ModuulitIcon(props) {
  return <AutoAwesomeMosaicIcon {...props} />;
}
